// @core/api/endpoints/workflow/delegate_decision.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DelegateDecisionRequest,
  PendingDecisionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Delegate decision
 * Reassigns an outstanding decision to another actor, recording who passed it on.
 */
export async function DelegateDecision(
  decision_id: string,
  data: DelegateDecisionRequest,
  options?: RequestOptions
): Promise<PendingDecisionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/decisions/:decision_id/delegate`;
  requestPath = requestPath.replace(':decision_id', encodeURIComponent(decision_id));
  const requestOptions = options;
  return client.post<PendingDecisionResponse>(requestPath, data, requestOptions);
}
